export const ARI_PREFIX = 'ari:cloud:identity::team/';
